import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Paper from 'material-ui/Paper'
import ControlPoint from 'material-ui/svg-icons/image/control-point'
import AddItemForm from '../common/AddItemForm'
import { prepareNewItemForApi } from '../utils'
import { makeAuthenticatedApi } from '../api'
import { handleSumbissionErrors } from '../form/errors'
import { themeColors } from '../styles/theme'

const styles = {
  title: {
    color: themeColors.positive,
    textTransform: 'uppercase',
  },
  titleIcon: {
    fill: themeColors.positive,
    position: 'relative',
    top: 5,
    marginRight: 5,
  },
}

// Categories where search item functionality is enabled...
const searchCategories = [1, 2, 3, 4, 50]

class AddItem extends PureComponent {
  handleSubmit = newItem => {
    const newItemForApi = prepareNewItemForApi(newItem)
    return this.props.api.addItem(newItemForApi).catch(handleSumbissionErrors)
  }

  handleSubmitOwned = (item, conditions) => {
    return this.props.api
      .iOwn(item.id, conditions)
      .catch(handleSumbissionErrors)
  }

  redirectToNewItem = newItem => {
    const { user } = this.props
    this.props.history.replace(`/item/${newItem.id}?userId=${user.id}`)
  }

  render() {
    return (
      <div className="padding">
        <Paper>
          <div className="padding">
            <div>
              <h3 style={styles.title}>
                <ControlPoint style={styles.titleIcon} />Nuovo Oggetto
              </h3>
              <p>
                Per aggiungere un nuovo oggetto da scambiare su Swapick, scegli il mondo,
                la categoria e compila tutti i campi richiesti.
                Per completare l'operazione dovrai allegare almeno un immagine dell'oggetto da caricare.
              </p>
            </div>
            <AddItemForm
              searchCategories={searchCategories}
              onSubmitOwned={this.handleSubmitOwned}
              onSubmitOwnedSuccess={this.redirectToNewItem}
              onSubmit={this.handleSubmit}
              onSubmitSuccess={this.redirectToNewItem}
            />
          </div>
        </Paper>
      </div>
    )
  }
}

export default connect(state => ({
  user: state.auth.user,
  api: makeAuthenticatedApi(state),
  categoriesBySlug: state.categoriesAndWorlds.categoriesBySlug,
}))(AddItem)



// WEBPACK FOOTER //
// ./src/pages/AddItem.js